<template>
  <div class="bank-verification-content">
    <div class="bank-verification-content__heading">
      <p>
        1-Step Bank Verification
      </p>

      <small>
        In order to get the fastest approval for the highest amount possible we need to verify your banking details.
      </small>

      <small>
        Select your bank and enter the same login details you use for your online banking.
      </small>
    </div>

    <FlinksIframe
      v-if="!flinksComplete"
      @bank-ready="submitFlinksInfo"
    />

    <section class="bank-verification-content__details">
      <div class="row-wrap">
        <!-- card image -->
        <figure>
          <img
            src="@/assets/svg/banking/credit-card-img.svg"
            alt="Black Banking Card"
          >
        </figure>

        <!-- login details -->
        <section>
          <p>
            <strong>Login Details</strong>
          </p>
          <p>Complete your bank verification by entering your online banking details.</p>
          <p>You can use your username or the 16 digit number on the front of your debit card and the same password you use when logging into your online banking.</p>
          <p>Bank Verification through this application is completely optional and not required to complete your application.</p>
        </section>
      </div>

      <div class="row-wrap">
        <!-- verification info -->
        <section>
          <p>
            <strong>Why Verify?</strong>
          </p>
          <p>Fast turnaround: Get your loan approval much faster compared to other options. Avoid having to search around and send in bank statements and void cheques.</p>
          <p>Get our best deal possible. By using our verification tool you are providing us with the most up to date transaction and income history allowing us to give you our best deal possible.</p>
        </section>

        <!-- security info -->
        <section>
          <p>
            <strong>Safe & Secure</strong>
          </p>
          <p>Bank Level Security: This service uses bank-level security with a 128 bit encryption. Canada Drives does not have access to or save your login and password.</p>
          <p>Read Only Information: The information retrieved is "read only". You are not giving anyone access to make changes or move money from your bank account by using this service.</p>
        </section>
      </div>
    </section>
  </div>
</template>

<script>
import FlinksIframe from '@/components/bank-verification/v1/FlinksIframe'
import axios from 'axios'

export default {
  name: 'BankVerificationContent',

  components: {
    FlinksIframe
  },

  props: {
    accountData: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      loginId: '',
      flinksCode: '',
      institution: '',
      flinksComplete: false
    }
  },

  methods: {
    /**
     * Submit Flinks Info
     * @emits verified
     */
    async submitFlinksInfo ({ loginId, institution, flinksCode }) {
      try {
        const { appId, account, cduid } = this.accountData
        const data = new FormData()

        data.append('Type__c', 'Bank Statements')
        data.append('Login_ID__c', loginId)
        data.append('Application__c', appId)
        data.append('Account__c', account)
        data.append('cduid', cduid)
        data.append('Flinks_Request_ID__c', 'undefined')
        data.append('Request_Status__c', flinksCode)
        data.append('Bank_institution__c', institution)
        data.append('Agent_Actions_Flinks__c', true)

        await axios.post(`${process.env.VUE_APP_LEAD_API_URL}/${process.env.VUE_APP_DOCUMENTS_URL || 'documents'}`, data)
        this.$emit('banking-finished', true)
      } catch (err) {
        this.$emit('banking-finished', false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.bank-verification-content {
  &__heading {
    text-align: center;
    color: $theme-text-black;

    // title
    p {
      font-weight: 600;
      margin: 26.5px auto 18px;

      @include breakpoint('tablet-portrait-up') {
        font-size: 25px;
        margin: 48.5px auto 30px;
      }

      @include breakpoint('desktop-up') {
        font-size: 35px;
        margin: 63.5px auto 36px;
      }
    }

    // subtitle
    small {
      display: block;
      font-size: 12px;
      padding: 0 40px;
      margin: 0 auto 30px;
      width: 100%;
      max-width: 330px;

      @include breakpoint('tablet-portrait-up') {
        font-size: 14px;
        padding: 0;
        max-width: 550px;

        &:last-of-type {
          margin-bottom: 60px
        }
      }

      @include breakpoint('desktop-up') {
        max-width: 100%;

        &:last-of-type {
          margin-bottom: 60px
        }
      }
    }
  }

  &__details {
    max-width: 900px;
    margin: 20px auto 30px;
    color: $theme-text-grey-dark;

    .row-wrap {
      display: flex;
      flex-wrap: wrap;
      padding: 0 20px;
      align-items: center;

      @include breakpoint('tablet-portrait-up') {
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        border-top: solid 1px #CCC;
        padding: 30px 20px;
        margin: 60px;
      }
    }

    section {
      @include breakpoint('tablet-portrait-up') {
        flex-basis: 40%;
      }

      p {
        line-height: 24px;
        font-size: 12px;
        color: $theme-text-black;

        @include breakpoint('tablet-portrait-up') {
          font-size: 14px;
        }
      }
    }

    figure {
      margin-top: 30px;

      @include breakpoint('tablet-portrait-up') {
        flex-basis: 45%;
        margin-top: 0px;
        margin-left: 0;
      }

      img {
        min-width: 140px;
        max-width: 100%;
        height: auto;
      }
    }
  }
}
</style>
